
import { Options, Vue } from 'vue-class-component';
import Configurator     from '@/views/configurator.vue';
import {mapGetters} from 'vuex';
import {
  ConfigurableAddonGroup,
  CpqCartProductJson,
} from './libs/cpq-builder/cpq-json.interface';
import { salesqueze } from './libs/salesqueze-sdk-browser';
import Loader from '@/components/shared/loader.vue';

@Options({
  components: {Loader, Configurator },
  computed: mapGetters(['getProducts']),
  async mounted() {
    //Redirect on refresh
    this.$router.push(`/start`);
    this.showLoader();

    let res = await salesqueze.getProducts({})

    let tiles = [];
    let curbs = [];
    let scarpElements = [];
    let grout = [];
    let impregnation = [];
    let addons = [];

    let linije = [];
    let oblike = [];
    res.data.items.forEach(x => {
      if(x.categoryKey === 'Tlakovec' || x.categoryKey === 'Betonska plošča'){
        if(x.media.gallery && x.propertyAttributes.find(x => x.key === 'linija') && x.propertyAttributes.find(x => x.key === 'oblika')){
          tiles.push(x);
          linije.push(x.propertyAttributes.find(x => x.key === 'linija').value)
          oblike.push(x.propertyAttributes.find(x => x.key === 'oblika').value)
        }
      } else if(x.categoryKey === 'Robnik'){
        curbs.push(x);
      } else if(x.categoryKey === 'Škarpni elementi'){
        scarpElements.push(x);
      } else if(x.categoryKey === 'Fugirne mase'){
        grout.push(x);
      } else if(x.categoryKey === 'Impregnacije'){
        impregnation.push(x);
      } else if(x.categoryKey === 'Dodatki'){
        addons.push(x);
      }
    })

    this.$store.commit('setResponseTiles', tiles)
    this.$store.commit('setResponseCurbs', curbs)
    this.$store.commit('setResponseScarpElements', scarpElements)
    this.$store.commit('setResponseGrouts', grout)
    this.$store.commit('setResponseImpregnation', impregnation)
    this.$store.commit('setResponseAddons', addons)


    //LINIJA CLASIFICATION

    let linijaRes = await salesqueze.getDataTable('linija-klasifikacija')

    const linijaList = linijaRes.data.map(x => {
      return {
        value: x._value,
        title: x._name,
        thumbnail: x._image
      }
    }).filter(x => linije.indexOf(x.value) !== -1)


    this.$store.commit('setLinijaList', linijaList)

    //OBLIKA CLASIFICATION

    let oblikaRes = await salesqueze.getDataTable('oblika-klasifikacija')

    const oblikaList = oblikaRes.data.map(x => {
      return {
        value: x._value,
        title: x._name,
        thumbnail: x._image
      }
    }).filter(x => oblike.indexOf(x.value) !== -1)


    this.$store.commit('setOblikaList', oblikaList)

    //SALONS

    let salonRes = await salesqueze.getDataTable('prodajna-mesta')

    const salonList = salonRes.data.map(x => {
      return {
        title: x._value,
        naslov: x.naslov,
        mesto: x.mesto,
        postnaStevilka: x.postnaStevilka,
        email: x.email,
        podjetje: x.podjetje,
        podjetjeNaslov: x.podjetjeNaslov,
        podjetjePostnaStevilka: x.podjetjePostnaStevilka
      }
    })

    this.$store.commit('setSalonList', salonList)

    this.hideLoader();

    this.$store.watch( (state) => {return this.$store.state.previewImageUrl}, x=> {
      this.nextDisabled = !x;
    })
  },
  watch: {
    '$store.state.salon'(value){
        value ? this.submitDisabled = false : this.submitDisabled = true
    }
  },
  data() {
    return{
      nextDisabled: true,
      submitDisabled: true,
      loaderActive: false
    }
  },
  methods: {
    showLoader () {
      this.loaderActive = true;
    },
    hideLoader () {
      this.loaderActive = false;
    },
    async handleSubmit () {
      this.showLoader();
      const state = this.$store.state;

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const locale = urlParams.get('lg') || 'sl-SI';
      const countryCode = locale.split('-')[1]

      const document = {
        metadata: {
          language: locale
        },
        cpq: {
          comment: state.contact.note,
          cart: {
            products: state.products
          },
          billingAddress: {
            name: `${state.contact.firstName} ${state.contact.lastName}`,
            address1: state.contact.address,
            city: state.contact.city,
            countryCode,
            postalCode: state.contact.postalCode,
            primary: true
          },
          billingAddressMatchesContact: true,
          shippingAddress: {
            name: `${state.contact.firstName} ${state.contact.lastName}`,
            address1: state.contact.deliveryAddress,
            city: state.contact.deliveryCity,
            countryCode,
            postalCode: state.contact.deliveryPostalCode,
            primary: true
          },
          shippingAddressMatchesBilling: state.contact.sameDeliveryAddress,
          paymentMethod: 'offer',
          payment: {
            term: {
              key: 'inquiry',
              type: 'inquiry'
            },
            method: undefined
          },
          contact: {
            firstName: state.contact.firstName,
            lastName: state.contact.lastName,
            email: state.contact.email,
            phoneNumber: state.contact.phone,
            address: {
              address1: state.contact.address,
              city: state.contact.city,
              countryCode,
              postalCode: state.contact.postalCode,
              primary: true
            }
          },
          deliveryType: state.contact.deliveryType === 'delivery' ? 'shipping' : 'pick-up',
          delivery: {
            term: {
              key: state.contact.deliveryType,
            }
          }
        }
      }
      debugger;
      await salesqueze.createDocument('cpq',document);
      setTimeout(() => {
        this.hideLoader();
        this.$router.push(`/done`);
      }, 2000);
    }
  }
})
export default class app extends Vue {
  
  async handleClickNext(): Promise<void> {
    this.$store.commit('incrementCounter');

    if(this.$router.currentRoute.value.name === 'Configure'){
      const errors = this.$store.state.errors;
      const activeErrors = {};
      activeErrors['tiles'] = errors.tiles || null
      if(activeErrors['tiles']){
        this.$store.commit('setActiveErrors', activeErrors)
      } else {
        this.$store.commit('set_takeScreenshot',true);
      }
    } else if(this.$router.currentRoute.value.name === 'Paving surface'){
      const errors = this.$store.state.errors;
      const activeErrors = {};
      activeErrors['pavingSurface'] = errors.pavingSurface || null
      if(activeErrors['pavingSurface']){
        this.$store.commit('setActiveErrors', activeErrors)
      }
    } else if(this.$router.currentRoute.value.name !== 'Your info'){
      this.$router.push(this.$router.currentRoute.value.meta.next)
    }
  }

  async handleClickBack(): Promise<void> {
    this.$router.push(this.$router.currentRoute.value.meta.prev)
}
}
